import React, { useEffect, useState } from 'react';
import { Button, Tooltip, Typography } from 'antd';
import styles from './data-marketplace-feed-panel.module.sass';
import cx from 'classnames';
import AnimatedCounter from '../AnimatedCounter';
import LoadingSkeleton from '../LoadingSkeleton';
import { incrementUIRequestsCounter } from '../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

function DataMarketplaceFeedPanel(props) {
  const { Text, Title, Paragraph } = Typography;
  const {
    setUuid,
    setModalFeedName,
    setShowAutomateExportModal,
    setShowDownloadModal,
    observableCount,
    serial,
    loading,
    restricted,
    feedName,
    obsType,
    updated,
    feedDescription,
    firstLoad,
    fileTypes,
  } = props;
  const [obsCount, setObsCount] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setObsCount(observableCount);
    }, 200);
  }, []);

  const formatObservableType = (type) => {
    if (type === 'ipv4' || type === 'ipv6') {
      return type.slice(0, 2).toUpperCase() + type.slice(2);
    } else {
      return type;
    }
  };

  return (
    <Tooltip
      title={restricted ? 'You have no access to this feed collection.' : ''}
      placement="right"
    >
      <div
        className={cx(styles.dataMarketplaceFeedsPanel, {
          [styles.restricted]: restricted,
        })}
      >
        {loading ? (
          <div className={cx(styles.topSection, styles.loading)}>
            <LoadingSkeleton />
          </div>
        ) : (
          <div className={styles.topSection}>
            <Tooltip title={feedName}>
              <Title
                className={styles.feedTitle}
                level={4}
                data-cy="dataMarketplaceFeedsPanelTitle"
              >
                {feedName}
              </Title>
            </Tooltip>

            <div className={styles.observables}>
              <Title level={4} data-cy="dataMarketplaceFeedsPanelCounter">
                {firstLoad ? (
                  observableCount ? (
                    observableCount
                  ) : (
                    0
                  )
                ) : (
                  <AnimatedCounter
                    serial={serial}
                    number={obsCount ? obsCount : 0}
                    duration={1}
                    delay={0}
                  />
                )}
              </Title>
              <Text>Observables</Text>
            </div>
          </div>
        )}

        {loading ? (
          <div className={cx(styles.content, styles.loading)}>
            <div className={styles.info}>
              <LoadingSkeleton />
            </div>
            <div className={cx(styles.info)}>
              <LoadingSkeleton />
            </div>
            <div className={cx(styles.description, styles.placement)}>
              <LoadingSkeleton />
            </div>
          </div>
        ) : (
          <div className={styles.content}>
            <div className={styles.info}>
              <Text>Observable Type:</Text>
              <Paragraph
                className={cx(styles.type, 'ms-05')}
                data-cy="dataMarketplaceFeedsPanelObservableType"
              >
                {formatObservableType(obsType)}
              </Paragraph>
            </div>
            <div className={cx(styles.info, 'mb-1')}>
              <Text>Last updated:</Text>
              <Paragraph
                className="ms-05"
                data-cy="dataMarketplaceFeedsPanelLastUpdated"
              >
                {updated}
              </Paragraph>
            </div>

            <div className={styles.description}>
              <Paragraph
                className="m-0"
                data-cy="dataMarketplaceFeedsPanelDescription"
              >
                {feedDescription}
              </Paragraph>
            </div>

            <div className={styles.fileTypes}>
              <Text>Available file types:</Text>
              {fileTypes?.length > 0 ? (
                <>
                  {fileTypes[0] && (
                    <Paragraph data-cy="dataMarketplaceCSVFileType">
                      CSV
                    </Paragraph>
                  )}
                  {fileTypes[1] && (
                    <Paragraph data-cy="dataMarketplaceJSONFileType">
                      JSON
                    </Paragraph>
                  )}
                  {fileTypes[2] && (
                    <Paragraph data-cy="dataMarketplaceTXTFileType">
                      TXT
                    </Paragraph>
                  )}
                  {fileTypes[3] && (
                    <Paragraph data-cy="dataMarketplaceRPZFileType">
                      RPZ
                    </Paragraph>
                  )}
                  {fileTypes[4] && (
                    <Paragraph data-cy="dataMarketplaceSTIXFileType">
                      STIX
                    </Paragraph>
                  )}
                </>
              ) : (
                <Paragraph>-</Paragraph>
              )}
            </div>
          </div>
        )}
        <div className={styles.bottomSection}>
          <Tooltip
            title={
              fileTypes?.includes(true)
                ? ''
                : 'There are no available file for this bulk data.'
            }
          >
            <Button
              data-cy="dataMarketplaceFeedsPanelAutomateExportButton"
              type="primary"
              disabled={restricted || loading || !fileTypes?.includes(true)}
              onClick={() => {
                setModalFeedName(feedName);
                setUuid(`${serial}`);
                setShowAutomateExportModal(true);
                incrementUIRequestsCounter();
              }}
            >
              Automate Export
            </Button>
          </Tooltip>

          <Tooltip
            title={
              fileTypes?.includes(true)
                ? ''
                : 'There are no available file for this bulk data.'
            }
          >
            <Button
              data-cy="dataMarketplaceFeedsPanelDownloadFileButton"
              className="ms-05"
              type="primary"
              disabled={restricted || loading || !fileTypes?.includes(true)}
              onClick={() => {
                setModalFeedName(feedName);
                setUuid(`${serial}`);
                setShowDownloadModal(true);
                incrementUIRequestsCounter();
              }}
            >
              Download File
            </Button>
          </Tooltip>
        </div>

        <div className={styles.gradient}></div>
      </div>
    </Tooltip>
  );
}

export default DataMarketplaceFeedPanel;
